import { DEFAULT_LANGUAGE } from 'constants/localization';

const AVAILABLE_LANGUAGES: Record<string, string> = {
    en: 'en',
    fr: 'fr',
    de: 'de',
    it: 'it',
    es: 'es',
    pt: 'pt',
};

const BASE_LINK = 'https://musclebooster.welltech.com';

export const getFaqLinks = (lang: string) => {
    const languageCode = AVAILABLE_LANGUAGES[lang] || AVAILABLE_LANGUAGES[DEFAULT_LANGUAGE];

    if (languageCode === 'en') {
        return `${BASE_LINK}/help-center`;
    }

    return `${BASE_LINK}/${languageCode}/help-center`;
};
